import { ComponentType } from '@angular/cdk/overlay';
import { Injectable, Injector, inject } from '@angular/core';

import { NonRootToken } from '@frontend/sports/host-app/sports-product/feature/non-root-token';

import { ModalOptions } from './modal';
import { ModalRef } from './modal-ref';
import { IModalWindowStackService, MODAL_WINDOW_STACK_TOKEN } from './modal-stack-config.token';

@Injectable({ providedIn: 'root' })
export class ModalStack {
    private modalWindowStackService = inject<IModalWindowStackService>(NonRootToken(MODAL_WINDOW_STACK_TOKEN));

    open(contentInjector: Injector, content: ComponentType<unknown>, options: ModalOptions): ModalRef {
        return this.modalWindowStackService.openModalWindow(contentInjector, content, options);
    }
}
